// const WEBSOCKET_API = `wss:/api-test.foodlocation.co/websocket/orderNotification?branchId=`
const WEBSOCKET_API = `https://apis1.foodlocation.co/ws/`;

export default WEBSOCKET_API;
